import React from 'react';
import {Link} from 'react-router-dom';
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import {Breadcrumbs, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import {ChevronLeftRounded, ChevronRightRounded} from "@mui/icons-material";
import {translateKey} from "../../../config/values";

class BreadCrumbs extends React.Component {
    classes = this.props.classes;

    render(){
        let {singleLevel,firstText,firstLink,secondText,locale,front,style} = this.props;
        return (
            <Breadcrumbs
                separator={<ChevronRightRounded/> }
                aria-label="breadcrumb" className={this.classes.breadCrumb} style={style}>
                {
                    !!front ?
                        <Link
                            to="/"
                            className={this.classes.BreadLink}
                        >
                            {translateKey('home')}
                        </Link>
                        :
                        <Link
                            to="/"
                            className={this.classes.BreadLink}
                        >
                            {translateKey('userPanel')}
                        </Link>
                }
                {
                    singleLevel ?
                        <strong className={this.classes.BreadLink}>
                            {firstText}
                        </strong> :
                        <Link
                            to={firstLink}
                            className={this.classes.BreadLink}
                        >
                            {firstText}
                        </Link>
                }
                {
                    !singleLevel ?
                        <strong className={this.classes.BreadLink}>
                            {secondText}
                        </strong> : null

                }

            </Breadcrumbs>
        );
    }
}
const mstp = state => ({
    locale: state.locale,
    Translate: state.Translate,
});
export default connect(mstp)(withStyles(Styles)(BreadCrumbs));
